import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ItemSide from './item-side/ItemSide'

class OrderMockUp extends Component {
    render() {
        const {mockUpFront, mockUpBack, mockUpSleeves, mockUpHood, ...rest} = this.props

        return (
            <div className='OrderMockUp'>
                <div className="FB">
                    {
                        mockUpFront && (
                            <ItemSide {...rest} type='update-mock-up' side='front' url={mockUpFront} layout='image'/>
                        )
                    }
                    {
                        mockUpBack && (
                            <ItemSide {...rest} type='update-mock-up' side='back' url={mockUpBack} layout='image'/>
                        )
                    }
                </div>
            </div>
        )
    }
}

OrderMockUp.defaultProps = {
    mockUpFront: '',
    mockUpBack: '',
}

OrderMockUp.propTypes = {
    mockUpFront: PropTypes.string,
    mockUpBack: PropTypes.string,
}

export default OrderMockUp
